import * as React from 'react'
import cc from 'classcat'
import Button from '../Button'

import s from './styles.module.css'

export default class SelectButton extends React.Component {
  render() {
    const {
      onClick,
      selected,
      children,
      className,
      selectedClassName
    } = this.props

    return (
      <Button
        onClick={onClick}
        className={cc([
          s.button,
          {
            [s.selected]: selected,
            [selectedClassName]: selected
          },
          className
        ])}
      >
        {children}
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectButton/index.js